"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPhoneNumber = void 0;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/slice"));
/**
 * Formats a phone number based on country
 *
 * @param phoneNumber The phone number to format
 * @param country The country format to use (defaults to United States)
 * @returns Formatted phone number string
 */
const formatPhoneNumber = (phoneNumber, country = 'United States') => {
  if (!phoneNumber) {
    return '';
  }
  const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
  if (country === 'United States' && cleanedPhoneNumber.length === 10) {
    const firstThreeDigits = (0, _slice.default)(cleanedPhoneNumber).call(cleanedPhoneNumber, 0, 3);
    const secondThreeDigits = (0, _slice.default)(cleanedPhoneNumber).call(cleanedPhoneNumber, 3, 6);
    const lastFourDigits = (0, _slice.default)(cleanedPhoneNumber).call(cleanedPhoneNumber, -4);
    return `(${firstThreeDigits}) ${secondThreeDigits}-${lastFourDigits}`;
  }
  return cleanedPhoneNumber;
};
exports.formatPhoneNumber = formatPhoneNumber;